import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { wikiEntries } from "./wikiData";

const pageItems = [
  { label: "Research Trajectory", href: "/research", type: "Page" },
  { label: "Opening Question", href: "/research#opening", type: "Section" },
  { label: "Lana and Yerkish", href: "/research#lana-yerkish", type: "Section" },
  {
    label: "Sherman and Austin",
    href: "/research/sherman-and-austin",
    type: "Subjects",
  },
  { label: "Reference", href: "/research#reference", type: "Section" },
  { label: "Kanzi and Development", href: "/research#kanzi", type: "Section" },
  { label: "Culture and Tools", href: "/research#culture", type: "Section" },
  { label: "Restoration", href: "/research#restoration", type: "Section" },
  {
    label: "Ernst von Glasersfeld",
    href: "/research/ernst-von-glasersfeld",
    type: "Person",
  },
  { label: "Lana", href: "/research/lana", type: "Subject" },
  { label: "Yerkes", href: "/research/yerkes", type: "Place" },
  { label: "Yerkish", href: "/research/yerkish", type: "Concept" },
  { label: "Kanzi", href: "/research/kanzi", type: "Subject" },
  { label: "Bonobos", href: "/research/bonobos", type: "Subject" },
  { label: "Pan", href: "/research/pan", type: "Genus" },
  {
    label: "Lexigrams",
    href: "/research/lexigrams",
    type: "Concept",
  },
  {
    label: "Correlational Grammar",
    href: "/research/ernst-von-glasersfeld#grammar",
    type: "Concept",
  },
  {
    label: "Operational Methodology",
    href: "/research/ernst-von-glasersfeld#methodology",
    type: "Concept",
  },
  {
    label: "LANA Project",
    href: "/research/lana#lana-project",
    type: "Project",
  },
  { label: "References", href: "#references", type: "Section" },
];

const pdfItems = wikiEntries.map((entry) => ({
  label: entry.title,
  href: entry.href,
  type: entry.year,
  external: true,
}));

const searchItems = [...pageItems, ...pdfItems];

const WikiSearch = () => {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const results = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return [];

    return searchItems
      .filter((item) => `${item.label} ${item.type}`.toLowerCase().includes(normalizedQuery))
      .slice(0, 8);
  }, [query]);

  const goToResult = (item) => {
    if (!item) return;

    if (item.external) {
      window.location.href = item.href;
      return;
    }

    navigate(item.href);
    setQuery("");
  };

  return (
    <div className="wiki-search">
      <label className="wiki-search-label" htmlFor="wiki-search">
        Search
      </label>
      <input
        id="wiki-search"
        type="search"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter" && results[0]) {
            event.preventDefault();
            goToResult(results[0]);
          }
        }}
        placeholder="Search"
      />
      {results.length > 0 && (
        <div className="wiki-search-results">
          {results.map((item) => (
            <a
              href={item.href}
              key={`${item.type}-${item.label}`}
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noreferrer" : undefined}
              onClick={(event) => {
                if (item.external) return;
                event.preventDefault();
                goToResult(item);
              }}
            >
              <span>{item.type}</span>
              {item.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default WikiSearch;
